<template>
  <div>
    <el-container>
      <el-main>
        <!-- 已经选择的内容tab -->
        <div v-show="viewType==='1'">
          <div class="modal-subtitle">已选择跨组{{selectCount}}个</div>
          <el-tabs v-model="actTab" type="card">
            <el-tab-pane name="2" label="坐席组" stretch :disabled="disableWb">
              <el-scrollbar class="custom_scrollbar" style="height:259.8px;">
                <div class="table-list">
                <el-table size="mini" row-key="" ref="zxzTableRef"  :data="selectedTreeData" :show-header="false">
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="name" label width="180"></el-table-column>
                </el-table>
              </div>
              </el-scrollbar>
            </el-tab-pane>
            <el-tab-pane name="3" label="技能组" stretch :disabled="disableSG">
              <el-scrollbar class="custom_scrollbar" style="height:259.8px;">
                <div class="table-list">
                <el-table size="mini" ref="jnzTableRef" :data="selectedTableData" :show-header="false" >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="name" label width="180"></el-table-column>
                </el-table>
              </div>
              </el-scrollbar>
            </el-tab-pane>
            <el-row>
              <el-col :span="12"><div class="grid-content">
                <el-button size="mini" @click="deleteSelectedData">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icontable-delete"></use>
                  </svg>
                </el-button>
              </div></el-col>
              <el-col :span="12"><div class="grid-content">
                <el-button
                  size="mini"
                  @click="editAcross"
                  style="border-left: none"
                >
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icontable-bianji"></use>
                  </svg>
                </el-button>
              </div></el-col>
            </el-row>
            <el-row>
              <el-col :span="12"><div class="grid-content">
                <el-button size="mini" @click="cancelAG" style="border-top: none">取消</el-button>
              </div></el-col>
              <el-col :span="12"><div class="grid-content">
                <el-button type="primary" size="mini" @click="confirmAG" style="border-left: none">确定</el-button>
              </div></el-col>
            </el-row>
          </el-tabs>
        </div>
        <!-- 选择坐席组，tree -->
        <div v-show="viewType==='2'">
          <div class="modal-subtitle">坐席组选择</div>
          <el-input
            class="selectInput"
            placeholder="输入关键字进行过滤"
            v-model="filterTreeText"
            size="small"
          >
            <svg slot="suffix" class="icon" aria-hidden="true">
              <use xlink:href="#iconsearchicon" />
            </svg>
          </el-input>
          <el-scrollbar class="custom_scrollbar" style="height:260px;margin-top:10px;margin-bottom:10px;">
            <el-tree style="height:100% !important;margin:0;"
              class="filter-tree"
              show-checkbox
              node-key="id"
              :data="treeData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              :ref="searchTreeRef"
            ></el-tree>
          </el-scrollbar>
          <el-row>
            <el-col :span="12"><div class="grid-content">
              <el-button size="small" @click="viewType='1'">取消</el-button>
            </div></el-col>
            <el-col :span="12"><div class="grid-content">
              <el-button type="primary" size="small" @click="confirmZxz">确定</el-button>
            </div></el-col>
          </el-row>
        </div>
        <!-- 选择技能组，table -->
        <div v-show="viewType==='3'">
          <div class="modal-subtitle">技能组选择</div>
          <el-input
            class="selectInput"
            placeholder="请输入关键字"
            v-model="searchTableText"
            size="small"
          >
            <svg slot="suffix" class="icon" aria-hidden="true">
              <use xlink:href="#iconsearchicon" />
            </svg>
          </el-input>
          <el-scrollbar class="custom_scrollbar" style="height:264px;margin-top:10px;margin-bottom:10px;">
            <div class="table-list">
              <el-table size="mini" ref="jnzMultipleTable"
              :data="filterTableText"
              :show-header="false"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label width="180"></el-table-column>
              </el-table>
            </div>
          </el-scrollbar>
          <el-row>
            <el-col :span="12"><div class="grid-content">
              <el-button size="mini" @click="cancelJnz">取消</el-button>
            </div></el-col>
            <el-col :span="12"><div class="grid-content">
              <el-button type="primary" size="mini" @click="confirmJnz">确定</el-button>
            </div></el-col>
          </el-row>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    selectedData: {
      type: Object,
      default: () => {
        return {
          selectedTableData: [],
          selectedTreeData: []
        }
      }
    },
    cancel: Function,
    confirm: Function,
    disableWb: {
      type: Boolean,
      default: false
    },
    disableSG: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchTreeRef: 'searchTreeRef',
      // 1:已选条目 2:选择坐席组（tree） 3:选择技能组（table）
      search: '', // 搜索
      viewType: '1',
      actTab: this.disableWb ? '3' : '2',
      filterTreeText: '',
      searchTableText: '',
      selectCount: 0,
      selectedTableData: [],
      selectedTreeData: [],
      curSelectedData: {},
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      selectedTreeDataId: [],
      testSG: false
    }
  },
  computed: {
    filterTableText: function() {
      var search = this.searchTableText
      if (search) {
        return this.tableData.filter(function(dataNews) {
          return Object.keys(dataNews).some(function(key) {
            return (
              String(dataNews[key])
                // .toLowerCase()
                .indexOf(search) > -1
            )
          })
        })
      }
      return this.tableData
    },
    tableData() {
      return this.$store.state.role.skillGroupData
    },
    treeData() {
      return this.$store.state.user.userGroupTree
    }/* ,
    selectedTreeDataId() {
      const ids = []
      for (var item in this.selectedTreeData) {
        ids.push(this.selectedTreeData[item].id)
      }
      // console.log(ids)
      return ids
    } */

  },
  components: {},
  watch: {
    filterTreeText(val) {
      this.$refs[this.searchTreeRef].filter(val)
    },
    selectedTreeData(arr) {
      const ids = []
      for (var item in arr) {
        ids.push(arr[item].id)
      }
      this.selectedTreeDataId = ids
    }
  },
  mounted() {
    this.$nextTick(function () {
      // 深拷贝
      this.curSelectedData = JSON.parse(JSON.stringify(this.selectedData))
      this.computeCount()
      if (typeof (this.curSelectedData.selectedTableData) !== 'undefined') {
        this.selectedTableData = this.curSelectedData.selectedTableData
        this.selectCount += this.selectedTableData.length
      }
      if (typeof (this.curSelectedData.selectedTreeData) !== 'undefined') {
        this.selectedTreeData = this.curSelectedData.selectedTreeData
        this.selectCount += this.selectedTreeData.length
      }
    })
  },
  methods: {
    confirmAG() {
      const selectedData = {}
      selectedData.selectedTableData = this.selectedTableData
      selectedData.selectedTreeData = this.selectedTreeData
      this.confirm(selectedData)
    },
    cancelAG() {
      this.cancel()
    },
    computeCount() {
      this.selectCount = this.selectedTableData.length + this.selectedTreeData.length
    },
    deleteSelectedData() {
      if (this.actTab === '3') {
        const selected = this.$refs.jnzTableRef.selection
        if (selected && selected.length > 0) {
          selected.forEach((v, i) => {
            const index = this.selectedTableData.findIndex(item => item.id === v.id)
            if (index !== -1) {
              this.selectedTableData.splice(index, 1)
            }
          })
        }
        this.computeCount()
      } else {
        const sled = this.$refs.zxzTableRef.selection
        if (sled && sled.length > 0) {
          sled.forEach((v, i) => {
            const index = this.selectedTreeData.findIndex(item => item.id === v.id)
            if (index !== -1) {
              this.selectedTreeData.splice(index, 1)
              // this.selectedTreeDataId.splice(index, 1)
            }
          })
        }
        this.computeCount()
      }
    },
    cancelJnz() {
      this.viewType = '1'
      this.actTab = '3'
    },
    confirmJnz() {
      const selects = this.$refs.jnzMultipleTable.selection
      const res = []
      selects.forEach((v) => {
        res.push((({ id, name }) => ({ id, name }))(v))
      })
      this.selectedTableData = res
      this.viewType = '1'
      this.actTab = '3'
      this.computeCount()
      // 跳出前清空选中，下次切换时会重新选中
      this.$refs.jnzMultipleTable.clearSelection()
    },
    filterNode(value, data) {
      if (!value) return true
      return data[this.defaultProps.label].indexOf(value) !== -1
    },
    confirmZxz() {
      const selects = this.$refs[this.searchTreeRef].getCheckedNodes(true)
      const res = []
      selects.forEach((v) => {
        res.push((({ id, name }) => ({ id, name }))(v))
      })
      this.selectedTreeData = res
      this.viewType = '1'
      this.computeCount()
    },
    editAcross() {
      if (this.actTab === '3') {
        // 选择技能组
        this.tableData.forEach((v) => {
          this.selectedTableData.forEach((selectedItem) => {
            if (v.id === selectedItem.id) {
              this.$refs.jnzMultipleTable.toggleRowSelection(v, true)
            }
          })
        })
      } else if (this.actTab === '2') {
        this.$refs[this.searchTreeRef].setCheckedKeys(this.selectedTreeDataId, true)
      }
      this.viewType = this.actTab
    }
  }
}
</script>
<style lang="scss" scoped>
/* 隐藏横线 */
/* .el-table>>>td{
  border: none;
} */

.el-tabs--card {
  .el-tabs__header {
    margin-bottom: 0;
    .el-tabs__nav {
      border-color: transparent;
    }
    .el-tabs__item {
      height: 28px;
      line-height: 28px;
    }
  }
  .el-tabs__content {
    overflow: auto;
    border-left: 1px solid #e1e3e6;
    border-right: 1px solid #e1e3e6;
    padding: 15px 20px;
  }
}

.el-tree {
  height: 250px;
  overflow-y: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.el-table {
  margin-top: 10px;
  margin-bottom: 10px;
}

.table-list .el-table tr td {
  height: auto;
  line-height: 1.2;
}

</style>
<style lang="scss">
  .table-list {
    .el-table {
      &:before {
        background-color: transparent;
      }
      .el-table__fixed-right {
        &:before {
          background-color: transparent;
        }
      }
      .el-table__fixed {
        &:before {
          background-color: transparent;
        }
      }

      tr {
        &.current-row {
          td {
            background-color: #edeef0;
            color: #337eff;

            .icon {
              color: #337eff;
            }
          }
        }

        &.hover-row {
          cursor: pointer;

          td {
            background-color: transparent;
            color: #337eff;

            .icon {
              color: #337eff;
            }
          }
        }

        td {
          border-bottom: none;
          height: auto;
          line-height: 1.2;
          padding-top: 0;
          padding-bottom: 0;
          color: #555;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;

          .cell {
            height: 23px;
          }
        }
      }
    }
  }
  .el-dialog .el-container .el-main .el-tabs .table-list .el-table--fit{height:100%;}
  .el-dialog .el-container .el-main .table-list .el-table--fit{height:100%;}
</style>
